import Request from '../lib/request'
import config from '../common/config'

const http = new Request
let token = localStorage.getItem('newToken')

export function uploadUrl() {
  return (config.host1 || '') + '/api/upload/file'
}

export function uploadImg() {
  return (config.host1 || '') + '/api/upload/image'
}

export default {
  // ===== 内容管理相关 API =====
  // 获取内容列表
  getContentList($d) {
    return http.get(config.host1, `/api/content/list`, $d)
  },
  // 获取内容详情
  getContentDetail($d) {
    return http.get(config.host1, `/api/content/detail`, $d)
  },
  // 保存/编辑内容
  saveContent($d) {
    return http.post(config.host1, `/api/content/save`, $d)
  },
  // 删除内容
  deleteContent($d) {
    return http.post(config.host1, `/api/content/delete`, $d)
  },
  // 批量删除内容
  batchDeleteContent($d) {
    return http.post(config.host1, `/api/content/batch-delete`, $d)
  },
  // 更新内容状态
  updateContentStatus($d) {
    return http.post(config.host1, `/api/content/update-status`, $d)
  },

  // ===== 分类管理相关 API =====
  // 获取分类列表
  getCategoryList($d) {
    return http.get(config.host1, `/api/category/list`, $d)
  },
  // 获取分类详情
  getCategoryDetail($d) {
    return http.get(config.host1, `/api/category/detail`, $d)
  },
  // 保存/编辑分类
  saveCategory($d) {
    return http.post(config.host1, `/api/category/save`, $d)
  },
  // 删除分类
  deleteCategory($d) {
    return http.post(config.host1, `/api/category/delete`, $d)
  },
  // 更新分类状态
  updateCategoryStatus($d) {
    return http.post(config.host1, `/api/category/update-status`, $d)
  },

  // ===== 用户管理相关 API =====
  // 获取用户列表
  getUserList($d) {
    return http.get(config.host1, `/api/user/list`, $d)
  },
  // 获取用户详情
  getUserDetail($d) {
    return http.get(config.host1, `/api/user/detail`, $d)
  },
  // 保存/编辑用户
  saveUser($d) {
    return http.post(config.host1, `/api/user/save`, $d)
  },
  // 删除用户
  deleteUser($d) {
    return http.post(config.host1, `/api/user/delete`, $d)
  },
  // 批量删除用户
  batchDeleteUser($d) {
    return http.post(config.host1, `/api/user/batch-delete`, $d)
  },
  // 更新用户状态
  updateUserStatus($d) {
    return http.post(config.host1, `/api/user/update-status`, $d)
  },
  // 获取角色列表
  getRoleList($d) {
    return http.get(config.host1, `/api/role/list`, $d)
  },

  // ===== 系统设置相关 API =====
  // 获取系统设置
  getSystemSettings($d) {
    return http.get(config.host1, `/api/system/settings`, $d)
  },
  // 保存系统设置
  saveSystemSettings($d) {
    return http.post(config.host1, `/api/system/settings-save`, $d)
  },
  // 测试邮件发送
  testEmail($d) {
    return http.post(config.host1, `/api/system/test-email`, $d)
  },

  // ===== 通用上传 API =====
  // 上传文件
  uploadFile($d) {
    return http.post(config.host1, `/api/upload/file`, $d)
  },
  // 上传图片
  uploadImage($d) {
    return http.post(config.host1, `/api/upload/image`, $d)
  },
  // 删除文件
  deleteFile($d) {
    return http.post(config.host1, `/api/upload/delete`, $d)
  },

  // ===== 用户认证相关 API =====
  // 用户登录
  login($d) {
    return http.post(config.host1, `/api/auth/login`, $d)
  },
  // 用户登出
  logout($d) {
    return http.post(config.host1, `/api/auth/logout`, $d)
  },
  // 获取当前用户信息
  getCurrentUser($d) {
    return http.get(config.host1, `/api/auth/current-user`, $d)
  },
  // 修改密码
  changePassword($d) {
    return http.post(config.host1, `/api/auth/change-password`, $d)
  },
  // 刷新token
  refreshToken($d) {
    return http.post(config.host1, `/api/auth/refresh-token`, $d)
  }
}



// WEBPACK FOOTER //
// ./src/api/center.api.js